import React from 'react';
import classNames from 'classnames';
import { Modal } from '../../';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import './ConfirmModal.scss';

export const ConfirmModal = ({ title, open, onCancel, onContinue, className, ghostCancel = false, children }) => {
    const cancelButtonProps = ghostCancel ? { className: 'confirm-modal-cancel--ghost' } : undefined;

    return (
        <Modal
            className={classNames('confirm-modal', className)}
            title={
                <div className="confirm-modal-header">
                    <ExclamationCircleOutlined className="confirm-modal-icon" />
                    <span>{title}</span>
                </div>
            }
            open={open}
            onCancel={onCancel}
            onOk={onContinue}
            okText="Continue"
            cancelText="Cancel"
            width={450}
            cancelButtonProps={cancelButtonProps}
        >
            {children}
        </Modal>
    );
};
